import { Option } from 'components/common/Option'
import { Select } from 'components/common/Select'
import useTranslation from 'next-translate/useTranslation'
import { useSortBy } from 'react-instantsearch'

const NEXT_PUBLIC_STAGE = process.env.NEXT_PUBLIC_STAGE
const RECOMMENDED_VALUE = `${NEXT_PUBLIC_STAGE}_filter`

export const SortBy = ({
  before,
  label,
  className,
}: {
  before?: string
  label?: string
  className?: string
}) => {
  const { t } = useTranslation('artworks')

  const {
    options: sortOptions,
    refine: refineSort,
    currentRefinement,
  } = useSortBy({
    items: [
      { label: t('recommended'), value: RECOMMENDED_VALUE },
      {
        label: t('lowest_ask'),
        value: `${NEXT_PUBLIC_STAGE}_filter_lowest_listing`,
      },
      {
        label: t('highest_bid'),
        value: `${NEXT_PUBLIC_STAGE}_filter_highest_bid`,
      },
      {
        label: t('newest_first'),
        value: `${NEXT_PUBLIC_STAGE}_filter_newest_first`,
      },
      {
        label: t('oldest_first'),
        value: `${NEXT_PUBLIC_STAGE}_filter_oldest_first`,
      },
      {
        label: t('common:latest_offers'),
        value: `${NEXT_PUBLIC_STAGE}_filter_latest_offers`,
      },
      {
        label: t('common:latest_listings'),
        value: `${NEXT_PUBLIC_STAGE}_filter_latest_listings`,
      },
    ],
  })

  return (
    <Select
      value={currentRefinement}
      size='md'
      onChange={value => {
        refineSort(value)
      }}
      inputClassName='!h-12'
      className={className}
      before={before}
      label={label}
    >
      {sortOptions.map(({ label, value }) => (
        <Option key={label} value={value}>
          {label}
        </Option>
      ))}
    </Select>
  )
}
